// Application types
export const APP_FACTORY_CONFIG = 1; // Factory provisioning application
export const APP_SMART_LOCKER_SHARE = 10; // Smart lock for shared access
export const APP_SMART_LOCKER_STORAGE = 11; // Locker terminal for personnel storage
export const APP_SMART_BOX_OWN = 12; // Personnel individual storage
export const APP_VEHICLE_OWN = 13; // Personnel vehicle access
export const APP_FLEET_VEHICLE_SHARE = 14; // Shared vehicle access
export const APP_FLEET_DRIVER_SHARE = 15; // Shared vehicle access
export const APP_SMART_LOCK_OWN = 16; // Smart lock for private access
export const APP_SMART_LOCK_SHARE = 17; // Locker terminal with shared access

// Token types
export const TOKEN_CONFIG_ROOT = 1; // root token
export const TOKEN_CONFIG_PBK = 3; // backup public key token
export const TOKEN_TRANS_SINGLE_USE_TIME_BOUNDED = 4; // token is for single use and works within
// timebound
export const TOKEN_TRANS_REPEAT_USE_TIME_BOUNDED = 5; // token is for multiple use and works within
// timebound
export const TOKEN_TRANS_SINGLE_USE_TIME_UNBOUNDED = 6; // token is for single use but ot time bounded
export const TOKEN_TRANS_PERIODIC_USE_TIME_BOUNDED = 7; // token is for periodic use

export const TOKEN_CONFIG_TAG = 8; // config tag
export const TOKEN_REMOVE_TAG = 9; // remove tag

export const TOKEN_SERVICE = 100;

// Actions
export const LOCKER_ACTION_NONE = 0;
export const LOCKER_ACTION_UNLOCK = 1;
export const LOCKER_ACTION_LOCK = 2;
export const LOCKER_ACTION_LOCK_STATUS = 3;
export const LOCKER_ACTION_LOCK_STATUS_ALL = 4;
export const LOCKER_ACTION_SERVICE_UNLOCK = 5;
export const LOCKER_ACTION_SERVICE_UNLOCK_ALL = 6;
export const LOCKER_ACTION_BATT_STATUS = 7;
export const LOCKER_ACTION_DISCONNECT_DEVICE = 8;
export const LOCKER_ACTION_TEMP_UNLOCK = 9;
export const LOCKER_ACTION_UNLOCK_WITH_PIN = 10;
export const LOCKER_ACTION_SET_PIN = 11;
export const LOCKER_ACTION_GET_PIN = 12;
export const LOCKER_ACTION_SET_MASTER_PIN = 13;
